export const styles = {
  pagination: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 0,
    gap: "37px",
    flex: "none",
    alignSelf: "stretch",
    flexGrow: 0,
    minHeight: "44px",

    "& $paginationRight": {
      "& .ant-pagination": {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "8px",

        "& .ant-pagination-prev, & .ant-pagination-next, & .ant-pagination-jump-prev, & .ant-pagination-jump-next, & .ant-pagination-item":
          {
            display: "flex",
            height: "32px",
            width: "32px",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            borderRadius: "40px",
            margin: 0,
            marginRight: 0,
            marginTop: 0,
            border: "2px solid #DDDFE6",

            "&:hover": {
              backgroundColor: "#F0F1F3",
            },

            "& a": {
              fontFamily: "Ubuntu",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "16px",
              display: "flex",
              alignItems: "center",
              color: "#1E293B",
              flex: "none",
              order: 0,
              flexGrow: 0,
              padding: 0,
              backgroundColor: "transparent",
              textDecoration: "none",
            },
          },
        "& .ant-pagination-jump-next, & .ant-pagination-jump-prev": {
          borderColor: "transparent",
        },
        "& .ant-pagination-prev, & .ant-pagination-next": {
          border: "2px solid transparent",
          "& a": {
            height: "auto",
            border: 0,
          },
        },

        "& .ant-pagination-item.ant-pagination-item-active": {
          borderColor: " #1E293B",
          background: "#1E293B",

          "& a": {
            color: "#ffffff",
            fontWeight: 700,
          },
        },
      },
    },

    "& $paginationLeft": {
      "& .ant-pagination": {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: 0,
        gap: 0,
        flex: "none",
        flexGrow: 0,

        "& .ant-pagination-item, & .ant-pagination-prev, & .ant-pagination-next, & .ant-pagination-jump-next, & .ant-pagination-jump-prev":
          {
            display: "none",
          },

        "& .ant-pagination-options, & .ant-pagination-options-size-changer.ant-select":
          {
            margin: 0,
          },

        "& .ant-pagination-options-size-changer.ant-select > .ant-select-selection":
          {
            borderRadius: "12px",
            border: "2px solid #CBD5E1",
          },

        "& .ant-select-selection--single": {
          height: "36px !important",
          padding: 0,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "8px",
        },

        "& .ant-select-open .ant-select-selection, & .ant-select-selection:active, & .ant-select-selection--single:active":
          {
            boxShadow: "none",
          },

        "& .ant-select-selection__rendered": {
          display: "flex",
          flex: "none",
          margin: 0,
          lineHeight: "16px",
          padding: "8px 16px",
          paddingRight: "40px",
        },

        "& .ant-select-selection-selected-value": {
          color: "#0F172A",
          fontFamily: "Ubuntu",
          fontSize: "14px",
          lineHeight: "normal",
          fontStyle: "normal",
          fontWeight: 500,
          padding: 0,
        },

        "& .ant-select-arrow": {
          display: "flex",
          color: "#1E293B",
          position: "inherit",
          marginTop: "auto",
          marginBottom: "auto",
          top: "unset",
          right: "unset",
          maxHeight: "16px",

          "& i, & svg": {
            width: "16px",
            height: "16px",
          },
        },
      },
    },
  },
  paginationSection: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: 0,
    gap: "8px",
    flex: "none",
    order: 0,
    flexGrow: 0,
  },
  paginationLeft: {},
  paginationRight: {
    alignItems: "flex-start",
    gap: "8px",
    order: 1,
  },
  pageSizeDropdown: {
    "&.ant-select-dropdown": {
      backgroundColor: "#fff",
      border: "1px solid #e3e5e6",
      borderRadius: "12px",
    },

    "& .ant-select-dropdown-menu": {
      padding: "10px 5px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gridGap: "4px",
    },

    "& .ant-select-dropdown-menu-item": {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      alignSelf: "stretch",
      borderRadius: "8px",
      minHeight: "30px",
    },

    "& .ant-select-dropdown-menu-item:hover": {
      backgroundColor: "#f5f5f5",
      color: "#1E293B",
    },

    "& .ant-select-dropdown-menu-item-active": {
      backgroundColor: "#f5f5f5",
      color: "#1E293B",
    },

    "& .ant-select-dropdown-menu-item-selected": {
      color: "#FFF",
      background: "#1E293B",
      fontWeight: 500,
    },
  },
  pagerInfo: {
    fontFamily: "Ubuntu",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "16px",
    display: "flex",
    alignItems: "center",
    color: "#85848B",
  },
};
